import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import makeStyles from "@mui/styles/makeStyles";
import { CustomButton } from "../../components/buttons";


const useStyles = makeStyles({
    text: {
        paddingRight: 15,
        borderRight: '1px solid #cce7e8'
    },
    form: {
        display: 'block'
    },
    icon: {
        display: 'block',
        fontSize: 100,
        textAlign: 'center',
        marginBottom: 20
    },
    aside: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    successText: {
        fontSize: 18,
        textAlign: 'center',
        textTransform: "none",
        backgroundColor: '#19B3CB',
        color: 'White'
    },
    laterText:
    {
        fontSize: 18,
        textAlign: 'center',
        textTransform: "none",
    }
});

export interface DialogProps {
    show: boolean;
    onPermission: (value: boolean) => void;
    onClose: () => void;
}

const JoinModalUnderAge = (props: DialogProps) => {
    const classes = useStyles();
    const { show, onPermission, onClose } = props;

    const handlePerm = (value: boolean) => {
        onPermission(value);
        handleClose();
    };
    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog open={show} scroll={'paper'} fullWidth={true} maxWidth="sm" onClose={handleClose}>
            <DialogContent>
                <p>KoçAilem'in avantaj dünyasındaki kampanyalardan haberdar olmak ve <br />
                    ayrıcalıklı hissetmek için elektronik ileti gönderim iznini vermelisin.</p>
            </DialogContent>
            <DialogActions>
                <CustomButton
                    text="Daha Sonra"
                    className={classes.laterText}
                    variant='text'
                    onClick={() => handlePerm(false)} />
                <CustomButton
                    text="İzin Ver"
                    className={classes.successText}
                    onClick={() => handlePerm(true)} />
            </DialogActions>
        </Dialog>
    );

}
export default JoinModalUnderAge;